import { render, staticRenderFns } from "./JiShiOnClock.vue?vue&type=template&id=6d8caf14&scoped=true"
import script from "./JiShiOnClock.vue?vue&type=script&lang=js"
export * from "./JiShiOnClock.vue?vue&type=script&lang=js"
import style0 from "./JiShiOnClock.vue?vue&type=style&index=0&id=6d8caf14&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d8caf14",
  null
  
)

export default component.exports